module.exports = __webpack_public_path__ + "static/media/bitmap-copy@3x.e6197c2d.png";